export default __webpack_public_path__ + "static/media/bridge.af36554f.png";